import { TimeZone } from '@cpak/interfaces';

export const TIMEZONES_CONFIG: TimeZone[] = [
  {
    timeZoneName: 'Etc/GMT+12',
  },
  {
    timeZoneName: 'Pacific/Pago_Pago',
  },
  {
    timeZoneName: 'US/Hawaii',
  },
  {
    timeZoneName: 'US/Alaska',
  },
  {
    timeZoneName: 'America/Tijuana',
  },
  {
    timeZoneName: 'US/Mountain',
  },
  {
    timeZoneName: 'US/Arizona',
  },
  {
    timeZoneName: 'Canada/Saskatchewan',
  },
  {
    timeZoneName: 'America/Mexico_City',
  },
  {
    timeZoneName: 'Canada/Central',
  },
  {
    timeZoneName: 'US/Central',
  },
  {
    timeZoneName: 'America/Indiana/Indianapolis',
  },
  {
    timeZoneName: 'US/Eastern',
  },
  {
    timeZoneName: 'Canada/Eastern',
  },
  {
    timeZoneName: 'America/Bogota',
  },
  {
    timeZoneName: 'America/Lima',
  },
  {
    timeZoneName: 'America/Santiago',
  },
  {
    timeZoneName: 'America/Caracas',
  },
  {
    timeZoneName: 'America/La_Paz',
  },
  {
    timeZoneName: 'Canada/Atlantic',
  },
  {
    timeZoneName: 'Canada/Newfoundland',
  },
  {
    timeZoneName: 'America/Nuuk',
  },
  {
    timeZoneName: 'America/Argentina/Buenos_Aires',
  },
  {
    timeZoneName: 'America/Sao_Paulo',
  },
  {
    timeZoneName: 'America/Noronha',
  },
  {
    timeZoneName: 'Atlantic/Cape_Verde',
  },
  {
    timeZoneName: 'Atlantic/Azores',
  },
  {
    timeZoneName: 'Etc/GMT-13',
  },
  {
    timeZoneName: 'Pacific/Fiji',
  },
  {
    timeZoneName: 'Asia/Kamchatka',
  },
  {
    timeZoneName: 'Pacific/Tarawa',
  },
  {
    timeZoneName: 'Pacific/Auckland',
  },
  {
    timeZoneName: 'Asia/Magadan',
  },
  {
    timeZoneName: 'Asia/Vladivostok',
  },
  {
    timeZoneName: 'Australia/Hobart',
  },
  {
    timeZoneName: 'Pacific/Guam',
  },
  {
    timeZoneName: 'Pacific/Port_Moresby',
  },
  {
    timeZoneName: 'Australia/Sydney',
  },
  {
    timeZoneName: 'Australia/Melbourne',
  },
  {
    timeZoneName: 'Australia/Brisbane',
  },
  {
    timeZoneName: 'Australia/Darwin',
  },
  {
    timeZoneName: 'Australia/Adelaide',
  },
  {
    timeZoneName: 'Asia/Yakutsk',
  },
  {
    timeZoneName: 'Asia/Seoul',
  },
  {
    timeZoneName: 'Asia/Tokyo',
  },
  {
    timeZoneName: 'Asia/Taipei',
  },
  {
    timeZoneName: 'Australia/Perth',
  },
  {
    timeZoneName: 'Asia/Singapore',
  },
  {
    timeZoneName: 'Asia/Irkutsk',
  },
  {
    timeZoneName: 'Asia/Ulaanbaatar',
  },
  {
    timeZoneName: 'Asia/Shanghai',
  },
  {
    timeZoneName: 'Asia/Hong_Kong',
  },
  {
    timeZoneName: 'Asia/Krasnoyarsk',
  },
  {
    timeZoneName: 'Asia/Bangkok',
  },
  {
    timeZoneName: 'Asia/Jakarta',
  },
  {
    timeZoneName: 'Asia/Novosibirsk',
  },
  {
    timeZoneName: 'Asia/Rangoon',
  },
  {
    timeZoneName: 'Asia/Urumqi',
  },
  {
    timeZoneName: 'Asia/Dhaka',
  },
  {
    timeZoneName: 'Asia/Almaty',
  },
  {
    timeZoneName: 'Asia/Kathmandu',
  },
  {
    timeZoneName: 'Asia/Kolkata',
  },
  {
    timeZoneName: 'Asia/Tashkent',
  },
  {
    timeZoneName: 'Asia/Karachi',
  },
  {
    timeZoneName: 'Asia/Yekaterinburg',
  },
  {
    timeZoneName: 'Asia/Kabul',
  },
  {
    timeZoneName: 'Asia/Baku',
  },
  {
    timeZoneName: 'Asia/Tbilisi',
  },
  {
    timeZoneName: 'Asia/Yerevan',
  },
  {
    timeZoneName: 'Asia/Dubai',
  },
  {
    timeZoneName: 'Asia/Tehran',
  },
  {
    timeZoneName: 'Africa/Nairobi',
  },
  {
    timeZoneName: 'Europe/Moscow',
  },
  {
    timeZoneName: 'Europe/Volgograd',
  },
  {
    timeZoneName: 'Asia/Riyadh',
  },
  {
    timeZoneName: 'Europe/Istanbul',
  },
  {
    timeZoneName: 'Europe/Minsk',
  },
  {
    timeZoneName: 'Asia/Jerusalem',
  },
  {
    timeZoneName: 'Europe/Helsinki',
  },
  {
    timeZoneName: 'Europe/Riga',
  },
  {
    timeZoneName: 'Europe/Tallinn',
  },
  {
    timeZoneName: 'Africa/Harare',
  },
  {
    timeZoneName: 'Africa/Cairo',
  },
  {
    timeZoneName: 'Europe/Bucharest',
  },
  {
    timeZoneName: 'Europe/Athens',
  },
  {
    timeZoneName: 'Europe/Sofia',
  },
  {
    timeZoneName: 'Europe/Vilnius',
  },
  {
    timeZoneName: 'Europe/Belgrade',
  },
  {
    timeZoneName: 'Europe/Warsaw',
  },
  {
    timeZoneName: 'Europe/Brussels',
  },
  {
    timeZoneName: 'Europe/Berlin',
  },
  {
    timeZoneName: 'Europe/Madrid',
  },
  {
    timeZoneName: 'Europe/Paris',
  },
  {
    timeZoneName: 'Europe/Belgrade',
  },
  {
    timeZoneName: 'Europe/Budapest',
  },
  {
    timeZoneName: 'Europe/Prague',
  },
  {
    timeZoneName: 'Europe/Rome',
  },
  {
    timeZoneName: 'Europe/Vienna',
  },
  {
    timeZoneName: 'Europe/Dublin',
  },
  {
    timeZoneName: 'Europe/Lisbon',
  },
  {
    timeZoneName: 'Europe/London',
  },
  {
    timeZoneName: 'Africa/Monrovia',
  },
];
